import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import styled from './styled.js';
import use from './use.js';
import { a as HiddenContainer } from './chunk-061cef7c.js';
import { c as HiddenToggle, b as HiddenShow, a as HiddenHide } from './chunk-22b2fb47.js';

var OverlayContainer = HiddenContainer;

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var OverlayToggle = styled(HiddenToggle)(_templateObject(), theme("OverlayToggle"));
var OverlayToggle$1 = use(OverlayToggle, "button");

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var OverlayShow = styled(HiddenShow)(_templateObject$1(), theme("OverlayShow"));
var OverlayShow$1 = use(OverlayShow, "button");

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var OverlayHide = styled(HiddenHide)(_templateObject$2(), theme("OverlayHide"));
var OverlayHide$1 = use(OverlayHide, "button");

export { OverlayContainer as a, OverlayToggle$1 as b, OverlayShow$1 as c, OverlayHide$1 as d };
